<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33">
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g>
                <path
                  fill="#E1F5FE"
                  d="M6.264 3.285L9.167 1.833 20.778 1.833 23.222 4.278 23.222 14.667 25.667 17.111 26.889 18.257 28.264 18.257 28.264 23.222 1.58 23.222 1.58 18.257 3.819 17.111 6.264 14.667z"
                  transform="translate(-165 -389) translate(127 318) translate(24 57) translate(14 14) translate(1.333 1.333)"
                />
                <path
                  fill="#13A2E8"
                  d="M14.667 24.444c-.675 0-1.223.548-1.223 1.223 0 .674.548 1.222 1.223 1.222.674 0 1.222-.548 1.222-1.222 0-.675-.548-1.223-1.222-1.223m0 4.89c-2.026 0-3.667-1.642-3.667-3.667C11 23.64 12.641 22 14.667 22c2.025 0 3.666 1.641 3.666 3.667 0 2.025-1.641 3.666-3.666 3.666"
                  transform="translate(-165 -389) translate(127 318) translate(24 57) translate(14 14) translate(1.333 1.333)"
                />
                <path fill="#164194" d="M0 24.444h29.333v-7.333H0v7.333zM2.444 22H26.89v-2.444H2.444V22z" transform="translate(-165 -389) translate(127 318) translate(24 57) translate(14 14) translate(1.333 1.333)" />
                <path
                  fill="#164194"
                  d="M26.025 19.197L22 15.173 22 4.173 20.272 2.444 9.062 2.444 7.333 4.173 7.333 15.173 3.309 19.197 1.58 17.469 4.889 14.161 4.889 3.161 8.05 0 21.284 0 24.444 3.161 24.444 14.161 27.753 17.469z"
                  transform="translate(-165 -389) translate(127 318) translate(24 57) translate(14 14) translate(1.333 1.333)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>